import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getVideosByType } from "@/lib/videoQuery";

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {categories.map((cat) => {
        const count = getVideosByType(cat.type).length;
        return (
          <Link
            key={cat.type}
            to={`/category/${cat.type}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/50"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
              <i className={`${cat.icon} text-2xl`} />
            </span>
            <div className="min-w-0">
              <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600">
                {cat.name}
              </h3>
              <p className="mt-1 truncate text-xs text-foreground-600">{cat.description}</p>
              <p className="mt-1.5 text-xs font-medium text-accent-600">共 {count} 部内容</p>
            </div>
            <i className="ri-arrow-right-s-line ml-auto text-xl text-foreground-300 transition-colors group-hover:text-primary-500" />
          </Link>
        );
      })}
    </div>
  );
}